import api from '@/services/api'
import type { MapaCargoSecao } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'
import type { MapaCargoOverridesMap } from '@/components/Configuracao/mapaCargos/mapaCargosMerge'

type OverridesResponse = {
  data: {
    overrides: MapaCargoOverridesMap
  }
}

type EscopoResponse = {
  data: {
    cargoId: string
    secoes: MapaCargoSecao[]
    updatedAt: string
  } | null
}

export const mapaCargosService = {
  async listOverrides(): Promise<MapaCargoOverridesMap> {
    const { data } = await api.get<OverridesResponse>('/mapa-cargos/overrides')
    return data.data.overrides
  },

  async saveEscopo(cargoId: string, secoes: MapaCargoSecao[]) {
    const { data } = await api.put<EscopoResponse>(`/mapa-cargos/${cargoId}/escopo`, { secoes })
    return data.data
  },

  async resetEscopo(cargoId: string) {
    await api.delete(`/mapa-cargos/${cargoId}/escopo`)
  },
}
